import { LOAD_BOT_ACTIVITY_BY_HANDLE_START, LOAD_BOT_ACTIVITY_BY_HANDLE_SUCCESS, LOAD_BOT_ACTIVITY_BY_HANDLE_ERROR } from "./actions";

// Initial state
const initialState = {
    botActivityByHandle: [],
    loading: false,
    error: null,
};

// Reducer function
export const botActivity = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_BOT_ACTIVITY_BY_HANDLE_START:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case LOAD_BOT_ACTIVITY_BY_HANDLE_SUCCESS:
            return {
                ...state,
                botActivityByHandle: action.payload,
                loading: false,
                error: null,
            };
        case LOAD_BOT_ACTIVITY_BY_HANDLE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};